import { useState } from 'react'

import { Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import payslipsDistributionStep1En from './assets/Payslips_Distribution_Step_1_en.svg'
import payslipsDistributionStep2En from './assets/Payslips_Distribution_Step_2_en.svg'
import payslipsDistributionStep3En from './assets/Payslips_Distribution_Step_3_en.svg'

interface Props {
  onClose?: () => void
  onFinish?: () => void
}

const HintModal = ({ onClose, onFinish }: Props) => {
  const [_step, setStep] = useState<number>(1)
  const [hasSeenHintModal, setHasSeenHintModal] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideDocumentPayslipsDistributionHint,
    false
  )

  if (hasSeenHintModal) return null

  const onCloseModal = () => {
    setHasSeenHintModal(true)
    onClose && onClose()
  }

  const onChangeModal = (newStep: string) => {
    setStep(parseInt(newStep))
  }

  const onFinishModal = () => {
    if (!hasSeenHintModal) {
      setHasSeenHintModal(true)
    }
    onFinish && onFinish()
  }

  return (
    <Hint.NewModal onClose={onCloseModal} onFinish={onFinishModal} onChange={onChangeModal}>
      <div id="1">
        <Hint.NewModal.ImageStep
          src={payslipsDistributionStep1En}
          title={i18n.t('split_documents.workflow_payslips.hint_modal.step_1.title')}
          description={i18n.t('split_documents.workflow_payslips.hint_modal.step_1.description')}
        />
      </div>
      <div id="2">
        <Hint.NewModal.ImageStep
          src={payslipsDistributionStep2En}
          title={i18n.t('split_documents.workflow_payslips.hint_modal.step_2.title')}
          description={i18n.t('split_documents.workflow_payslips.hint_modal.step_2.description')}
        />
      </div>
      <div id="3">
        <Hint.NewModal.ImageStep
          src={payslipsDistributionStep3En}
          title={i18n.t('split_documents.workflow_payslips.hint_modal.step_3.title')}
          description={i18n.t('split_documents.workflow_payslips.hint_modal.step_3.description')}
        />
      </div>
    </Hint.NewModal>
  )
}

export default observer(HintModal)
